import { UserTechMessageDialogComponent } from '../user-tech-dialogs/user-tech-message-dialog.component';
import { TechMessage } from 'src/app/models/tech/tech-message.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import { TechService } from 'src/app/services/tech.service';
import { MatDialog } from '@angular/material/dialog';
import {
  Input,
  inject,
  OnChanges,
  Component,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-user-tech-messages',
  templateUrl: './user-tech-messages.component.html',
  styleUrl: './user-tech-messages.component.scss',
})
export class UserTechMessagesComponent implements OnChanges {
  private _techService: TechService = inject(TechService);
  public isError: boolean = false;
  public loading: boolean = true;
  public error?: ApiError;

  @Input() startLoading: boolean = false;
  @Input() userId?: string;

  techMessages: TechMessage[] = [];

  constructor(private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['startLoading']?.currentValue &&
      !changes['startLoading']?.previousValue
    ) {
      this.loading = true;
      setTimeout(() => this.getTechMessagesData(), 1500);
    }
  }

  async getTechMessagesData() {
    this.loading = true;
    this.isError = false;
    this.error = undefined;

    this._techService
      .getUserTechMessages(this.userId)
      .subscribe({
        next: (data) => {
          if (data.data != undefined && (data.data as TechMessage[])) {
            this.techMessages = [];
            data.data.forEach((message: any) => {
              this.techMessages.push(new TechMessage(message));
            });
          }
        },
        error: (error) => {
          this.isError = true;
          this.error = new ApiError(error);
          console.error('User Techs Messages Error: ', error);
        },
      })
      .add(() => (this.loading = false));
  }

  postTechMessage(): void {
    const dialogSize = '450px';
    const dialogRef = this.dialog.open(UserTechMessageDialogComponent, {
      maxWidth: dialogSize,
      minWidth: dialogSize,
      autoFocus: false,
      restoreFocus: false,
      data: { userId: this.userId },
    });
    dialogRef.afterClosed().subscribe((dialogResult: any) => {
      // Se il dialog ritorna esito positivo ricarico i dati del widget
      if (dialogResult === true) this.getTechMessagesData();
    });
  }
}
